var app = angular.module('directives.paymentCreate');

app.directive('paymentCreate', [
    'configs',
    '$state',
    '$rootScope',
    function (configs, $state, $rootScope) {
        var tmplUrl;

        try {
            tmplUrl = require('../templates/' + $state.current.name.replace('pages.', '') + '.html');//looking for template with moduleName
        } catch (e) {
            tmplUrl = require('../templates/index.html')//if error(no such file), use default template
        }

        var parsedLink = $state.current.url.split("/");
        parsedLink.forEach(function(key) {
            if (key == 'l') {
                tmplUrl = require('../templates/index.html');
            }
            if (key == 'ls') {
                tmplUrl = require('../templates/service.html');
            }
        })

        return {
            template: tmplUrl,
            controller: 'createCtrl',
            link: function (scope, element, attrs, ctrl) {
            }
        }

    }
]);

app.controller('createCtrl', function ($scope, Pay, Counters) {
    $scope.pay = Pay;

    $scope.selectProduct = function (product, mUnit) {
        if ($scope.pay.innerState === 'create') {
            Counters.selectProduct(product, mUnit);
        }
    }
});



/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/paymentCreate/directives/paymentCreate.js
 ** module id = 199
 ** module chunks = 1
 **/